import { connect } from 'react-redux';
import React, { Component } from 'react';
import { List } from 'immutable';
import '../../less/alert.less';


class AlertError extends Component {
  render() {
    if (!this.props.errors) return null;
    const messages = this.props.messages ||
      this.props.errors.get('messages').map((msg, index) => <div key={index}>{msg}</div>);

    return (
      <div className="alert alert-danger">
        {messages}
      </div>
    );
  }
}

//TODO this looks kind of wonky but will be refactored out when the service is updated
//will need to move this logic outside of component and into some mapper in the action
function mapStateToProps(state) {
  let messages = null
  if (state.get('searchErrors')) {
    const credentialsErrorMessages = state.getIn(['searchErrors', 'messages'], List()).some((str) => str.match(/PACER login rejected|Unable to decrypt supplied password|Username supplied without password/i))
    const credentialsErrorDetails = state.getIn(['searchErrors', 'details'], List()).some((str) => str.match(/PACER login rejected|Unable to decrypt supplied password|Username supplied without password/i));

    if (credentialsErrorMessages || credentialsErrorDetails)
      messages = state.getIn(['user', 'settings', 'firmMember']) ?
        <div>
          Your firm's PACER credentials are not working.
          Please make sure to contact {state.getIn(['user', 'settings', 'firmMaster'])} to update your firm's PACER
          credentials so everything works
          properly.
        </div> :
        <div>
          Your PACER credentials are no longer working. If you have recently updated your PACER account or
          password,<br/>
          <a target="_blank" href={`/user/${state.getIn(['user', 'settings', 'currentUser'])}/edit`}>please update the
            same on our site here</a>.
        </div>
  }

  return {
    errors: state.get('validationErrors') || state.get('searchErrors'),
    messages: messages,
  };
}

export default connect(mapStateToProps)(AlertError);



/** WEBPACK FOOTER **
 ** ./src/components/common/AlertError.js
 **/